export interface HtmlText {
    html: string;
    text: string;
}

export interface ChoiceApiModel {
    answer: HtmlText;
    id: string;
    quantity_available: number;
    quantity_sold: number;
    subquestion_ids: string[];
}

export enum RespondentType {
    attendee = 'attendee',
    buyer = 'ticket_buyer',
    direct = 'direct',
}

export interface QuestionApiModel {
    choices: ChoiceApiModel[];
    display_answer_on_order: boolean;
    editable?: boolean;
    group_id?: string;
    id: string;
    include?: boolean;
    parent_id?: string;
    question: HtmlText;
    required: boolean;
    resource_uri: string;
    respondent: RespondentType;
    sorting: number;
    status?: string;
    ticket_classes: { id: string; name: string }[];
    type: string;
    waiver: string;
}
